<template>
  <div class='animated fadeIn'>
      <b-card>
          <b-row>
          <b-col sm='5'><label for='input-none'>グループ</label></b-col>
            <div class='ml-auto p-2 align-middle'>
              <el-button type='warning' icon='el-icon-plus' circle v-on:click='addButton()'></el-button>
            </div>
          </b-row>
        <b-card-body>
          <b-row>
            <b-col>
              <div class='table-responsive'>
                <b-table
                  :items='groups'
                  :fields='fields'
                  :current-page='currentPage'
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :per-page='perPage'>
                  <div slot='icon' class='avatar' slot-scope='item'>
                    <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                  </div>
                  <div slot='users' slot-scope='item'>
                    {{ getUsers(item) }}
                  </div>
                  <div slot='updatedAt' slot-scope='item'>
                    {{ item.value * 1000 | moment }}
                  </div>
                  <div slot='createdAt' slot-scope='item'>
                    {{ item.value * 1000 | moment }}
                  </div>
                  <div slot='key' slot-scope='item'>
                    <p v-if='authUser.role === "admin"' class='small text-muted'>{{ item.value }}</p>
                    <div class='mr-auto align-middle'>
                      <el-button type='success' icon='el-icon-edit' circle v-on:click='editButton(item.value)'></el-button>
                    </div>
                  </div>
                </b-table>
              </div>
            <b-pagination align='center' size='sm' :total-rows='groups.length' v-model='currentPage' :per-page='perPage'>
            </b-pagination>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      sortBy: 'createdAt',
      sortDesc: false,
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center',
          sortable: true
        },
        subTitle: {
          label: '説明',
          class: 'text-center',
          sortable: true
        },
        users: {
          label: '登録人数',
          class: 'text-center'
        },
        updatedAt: {
          label: '更新日時',
          class: 'text-center m-0',
          sortable: true
        },
        createdAt: {
          label: '作成日時',
          class: 'text-center m-0',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      currentPage: 1,
      perPage: 10
    }
  },
  created () {
  },
  computed: {
    ...mapGetters({
      groups: 'group/groups',
      authUser: 'authUser/user'
    })
  },
  methods: {
    editButton (key) {
      this.$store.dispatch('dispatch/setGroup', key).then(() => {
        this.$router.push({path: 'groups/edit'})
      })
    },
    addButton () {
      this.$store.dispatch('dispatch/setGroup', null).then(() => {
        this.$router.push({path: 'groups/register'})
      })
    },
    getUsers (value) {
      var number = 0
      for (var index in value.item.users) {
        if (value.item.users[index]) {
          number += 1
        }
      }
      return number
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Groups.vue